import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { TriangleAlert } from 'lucide-react';
import { isApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

/** Router error boundary: shows API errors (404, 403…) and unexpected render errors. */
export function RouteErrorPage() {
  const error = useRouteError();
  let title = 'Something went wrong';
  let description = 'An unexpected error occurred while rendering this page.';
  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    description = typeof error.data === 'string' ? error.data : description;
  } else if (isApiError(error)) {
    title = error.status === 404 ? 'Not found' : `Request failed (${error.status})`;
    description = error.message;
  } else if (error instanceof Error) {
    description = error.message;
  }
  return (
    <div className="flex min-h-[50vh] items-center justify-center p-6">
      <EmptyState
        icon={TriangleAlert}
        title={title}
        description={description}
        className="w-full max-w-md"
        action={
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => window.location.reload()}>
              Reload
            </Button>
            <Button asChild>
              <Link to="/">Dashboard</Link>
            </Button>
          </div>
        }
      />
    </div>
  );
}
